/* eslint-disable */
import { useEffect, useMemo, useRef, useState } from "react";
import { Grid, Typography, Box, Link, Button, Container, styled, Card, useTheme, FormControl, Select, MenuItem, Avatar } from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useMutation } from "@apollo/client";
import { useNavigate, useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { useQuery } from '@apollo/client';
import { addKanbanTags, deleteKanbanTag, updateKanbanTag, createKanbanColumn, updateKanban, updateKanbanColumn, deleteKanbanColumn } from "../../gql/mutations/kanban";
import MainLoader from "../MainLoader/MainLoader";
import { useKanbanData } from "../../hooks/userWebsiteData";
import { getPriorityFilteredFlags, initialColumns } from "../../common/utils";
import IssuePopup from "./IssuePopup";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { usePopup } from "../../context/commonPop";
import PipelineModal from "../Add-Pipeline";
import KanbanBoardHeader from "./KanbanBoardHeader";
import { useSelector } from "react-redux";
import KanbanEmptyState from "./KanbanEmptyState";
import RefreshIcon from "@mui/icons-material/Refresh";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import FlagIcon from "@mui/icons-material/Flag";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AddTeamMember from './AddTeampopup';
import { GET_KANBAN_TEAM_MEMBERS } from '../../gql/mutations/kanban';


const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 70px)",
  backgroundColor: theme.palette.background.default,
  paddingBottom: "60px",
  "& .DragListFilterWrapper": {
    "& .ContentWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "15px",
      marginBottom: "15px",
      "@media screen and (max-width:600px)": {
        flexDirection: "column",
        alignItems: "stretch",
      },
      "& h2": {
        fontSize: "20px",
        fontWeight: 700,
      },
      "& button": {
        textTransform: "none",
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: "5px",
        boxShadow: "none",
        padding: "6px 16px",
        "@media screen and (max-width:600px)": {
          width: "100%",
          padding: "6px 22px",
        },
        "&:focus": {
          outline: "0",
        },
      },
    },
    "& .FilterWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexWrap: "wrap",
      gap: "15px",
      "@media screen and (max-width:600px)": {
        flexDirection: "column",
        alignItems: "stretch",
      },
      "& .DropDownWrapper": {
        minWidth: "200px",
        "& .MuiInputBase-root": {
          "& .MuiSelect-select": {
            padding: "8px 12px 8px 12px",
          },
        },
      },
      "& button": {
        textTransform: "none",
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: "5px",
        boxShadow: "none",
        padding: "6px 16px",
        gap: "5px",
        "@media screen and (max-width:600px)": {
          width: "100%",
          padding: "6px 22px",
        },
        "&:focus": {
          outline: "0",
        },
        "& .Rotate": {
          animation: "rotate 2s infinite linear",
          "@keyframes rotate": {
            "0%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(360deg)" },
          },
        },
      },
    },
  },
  "& .DragListMainWrapper": {
    "& .DragInnerListWrapper": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      gap: "16px",
      overflow: "auto",
      maxHeight: "95vh",
      "&::-webkit-scrollbar-track": {
        borderRadius: "10px",
        backgroundColor: theme.palette.text.primary + "0d",
      },
      "&::-webkit-scrollbar": { width: "8px", height: "8px", backgroundColor: "transparent" },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: "10px",
        WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,.3)",
        backgroundColor: theme.palette.primary.main,
      },
      "& .MainBlockWrapper": {
        width: "270px",
        minWidth: "270px",
        backgroundColor: theme.palette.mode === "dark" ? "#f6f6f61A" : "#F6F6F6",
        borderRadius: "6px",
        padding: "6px 6px 6px",
        border: theme.palette.mode === "dark" ? `1px solid ${theme.palette.divider}` : "none",
        display: "block",
        height: "auto",
        overflow: "visible",
        "&.open": { backgroundColor: "#097CBF1A" },
        "&.progress": { backgroundColor: "#00B6FF1A" },
        "&.reopen": { backgroundColor: "#FFAA001A" },
        "&.closed": { backgroundColor: "#00FFEA1A" },
        "& .BlockHeadWrapper": {
          boxShadow: `0px 2px 4px 0px  ${theme.palette.mode === "dark" ? "#ffffff2b" : "#0000000D"}`,
          backgroundColor: theme.palette.mode === "dark" ? "#ffffff70" : "#ffffff",
          borderRadius: "3px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 7px 8px 10px",
          marginBottom: "10px",
          gap: "10px",
          "& h4": {
            fontSize: "14px",
            fontWeight: 700,
            lineHeight: 1,
          },
          "& .BtnWrapper": {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "6px",
            "& svg": {
              fontSize: "20px",
              cursor: "pointer",
            },
          },
        },
        "& .BlockBodyWrapper": {
          minHeight: "70vh",
          "& .DragBoxWrapper": {
            backgroundColor: theme.palette.mode === "dark" ? "#ffffff2b" : "#ffffff",
            padding: "12px 10px 12px",
            marginBottom: "8px",
            borderRadius: "3px",
            "&:last-of-type": {
              marginBottom: "0px",
            },
            "& .ContentWrapper": {
              "& .StatusTagsWrapper": {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                flexWrap: "wrap",
                gap: "4px",
                marginBottom: "16px",
                "& span": {
                  backgroundColor: theme.palette.mode === "dark" ? "#ffffff2b" : "#F1F1F3",
                  padding: "8px 14px 10px",
                  borderRadius: "50px",
                  fontSize: "12px",
                  fontWeight: 700,
                  lineHeight: 1,
                  display: "inline-block",
                  whiteSpace: "nowrap",
                  textTransform: "capitalize",
                  "&.FlagTag": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px",
                    padding: "4px 14px 6px",
                    "& svg": { fontSize: "20px" },
                  },
                  "&.High": { color: "#CC3F74" },
                  "&.Medium": { color: "#F27C27" },
                  "&.Low": { color: "#00B400" },
                },
              },
              "& .IssueName": {
                backgroundColor: theme.palette.mode === "dark" ? "#ffffff2b" : "#F1F1F3",
                padding: "8px 14px 10px",
                borderRadius: "50px",
                fontSize: "12px",
                fontWeight: 700,
                lineHeight: 1,
                marginBottom: "4px",
                display: "inline-block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              },
              "& h3": {
                fontSize: "14px",
                fontWeight: 700,
                marginBottom: "8px",
              },
              "& a": {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "12px",
                width: "100%",
                display: "block",
              },
              "& .TagsWrapper": {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                flexWrap: "wrap",
                gap: "4px",
                marginTop: "12px",
                paddingBottom: "12px",
                borderBottom: `1px solid ${theme.palette.mode === "dark" ? "#ffffff3d" : "#e5eaef"}`,
                "& span": {
                  backgroundColor: "transparent",
                  padding: "5px 12px 6px",
                  borderRadius: "50px",
                  fontSize: "12px",
                  fontWeight: 700,
                  lineHeight: 1,
                  display: "inline-block",
                  whiteSpace: "nowrap",
                  border: "1px solid",
                  "&:nth-child(odd)": {
                    color: "#FCA58B",
                    borderColor: "#FCA58B",
                  },
                  "&:nth-child(even)": {
                    color: "#2E91B1",
                    borderColor: "#2E91B1",
                  },
                },
              },
              "& .FooterWrapper": {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingTop: "10px",
                "& .AssignWrapper": {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "& .MuiAvatar-root": {
                    border: "1px solid #ffffff",
                    fontSize: "10px",
                    width: "28px",
                    height: "28px",
                    marginLeft: "-10px",
                    position: "relative",
                    cursor: "pointer",
                    textTransform: "uppercase",
                    color: "#ffffff",
                    "&:hover": { zIndex: "1" },
                    "&:first-of-type": {
                      marginLeft: "0px",
                    },
                    "&:nth-child(1)": { backgroundColor: "#66BAEA" },
                    "&:nth-child(2)": { backgroundColor: "#668CEA" },
                    "&:nth-child(3)": { backgroundColor: "#aa66ea" },
                    "&:nth-child(4)": { backgroundColor: "#eaab66" },
                    "&:last-of-type": { backgroundColor: theme.palette.primary.main },
                  },
                },
                "& .InfoWrapper": {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "10px",
                  "& .InfoInnerWrapper": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "3px",
                    fontSize: "14px",
                    fontWeight: 700,
                    cursor: "default",
                    "& svg": {
                      color: "#959AA3",
                      fontSize: "18px",
                    },
                  },
                },
              },
            },
          },
          "& .ShowMoreBtnWrapper": {
            "& button": {
              backgroundColor: theme.palette.mode === "dark" ? "#2A3547" : "#ffffff",
              borderRadius: "3px",
              width: "100%",
              color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
              fontWeight: 700,
              "&:focus": {
                outline: "none",
              },
            },
          },
        },
      },
    },
  },
}));

function KanbanView() {
  const theme = useTheme();
  const [widthLoader, setWidthLoader] = useState(false);
  const customizer = useSelector(state => state.customizer);
  const { projectId } = useParams();
  const [ADD_TAGS] = useMutation(addKanbanTags);
  const [DELETE_TAG] = useMutation(deleteKanbanTag);
  const [UPDATE_TAG] = useMutation(updateKanbanTag);
  const [UPDATE_KANBAN] = useMutation(updateKanban);
  const [DELETE_KANBAN_COlUMN] = useMutation(deleteKanbanColumn);
  const [CREATE_KANBAN_COLUMN] = useMutation(createKanbanColumn);
  const [UPDATE_KANBAN_COLUMN] = useMutation(updateKanbanColumn);
  const [UPDATE_COLUMN_POSITION] = useMutation(updateKanbanColumn);
  const [columnsState, setColumnsState] = useState(initialColumns);
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState({
    priority: "",
    assignee: "",
    tag: "",
  });
  const [showAddTeamMember, setShowAddTeamMember] = useState(false); // new state for popup
  const [tagInputVisibleFor, setTagInputVisibleFor] = useState(null);
  const [newTag, setNewTag] = useState({});
  const [editingTagId, setEditingTagId] = useState(null);
  const [editedTagValue, setEditedTagValue] = useState("");
  const [showPipelineModal, setShowPipelineModal] = useState(false);
  const [editPipelineModal, setEditPipelineModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editPipelineData, setEditPipelineData] = useState(null);
  const [selectedPipeline, setSelectedPipeline] = useState(null);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [kanbanLoad, setKanbanLoad] = useState(false)
  const [selectedAssigneesFilter, setSelectedAssigneesFilter] = useState([]);
  const columnBodyRefs = useRef({}); // refs for each column body
  const [isOverflowing, setIsOverflowing] = useState({}); // overflow state for each column
  const { data: teamMembersData, loading: teamMembersLoading, refetch: refetchTeamMembers } = useQuery(GET_KANBAN_TEAM_MEMBERS, {
    variables: { projectId },
  });
  // console.log("Project ID sent to query:", projectId);

  const teamMembers = teamMembersData?.kanbanTeamMembers || [];
  // console.log("Fetched team members:", teamMembers);
  const inputRef = useRef(null);
  const editInputRef = useRef(null);
  const navigate = useNavigate();
  const { handleOpen } = usePopup();
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const [issueId, setIssueId] = useState("");
  const selectedFlags = useMemo(() => {
    const raw = searchParams.get("flags");
    return raw ? raw.split(",") : [];
  }, [searchParams]);

  const handleAssigneesChange = (newAssignees) => {
    setSelectedAssigneesFilter(newAssignees);
    // You can also call refetch or apply filtering here based on newAssignees
    // console.log("selected assignees:", SelectedAssigneesFilter);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (editingTagId && editInputRef.current && !editInputRef.current.contains(event.target)) {
        setEditingTagId(null);
        setEditedTagValue("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editingTagId]);

  const { fetchIssuesByStatus, loading, kanbanColumns, setKanbanColumns, fetchInitialKanbanData } = useKanbanData(
    projectId,
    selectedFlags,
    setSearchParams,
    columnsState,
    setColumnsState,
  );

  const updateFilter = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
    }));
  };


  const handleEditPipeline = col => {
    setEditPipelineData(col);
    setEditPipelineModal(true);
  };

  useEffect(() => {
    fetchInitialKanbanData();
  }, [selectedIssue]);

  useEffect(() => {
    if (!loading) {
      setKanbanLoad(true);
    }
  }, [loading]);

  // const handleDragEnd = async result => {
  //   const { source, destination, draggableId, type } = result;
  //   if (!destination) return;

  //   if (type === "COLUMN") {
  //     const sortedColumns = [...kanbanColumns].sort((a, b) => a.columnPosition - b.columnPosition);
  //     const [movedCol] = sortedColumns.splice(source.index, 1);
  //     sortedColumns.splice(destination.index, 0, movedCol);

  //     const updatedColumns = sortedColumns.map((col, idx) => ({
  //       ...col,
  //       columnPosition: idx + 1,
  //     }));

  //     setKanbanColumns(updatedColumns);

  //     try {
  //       await Promise.all(
  //         updatedColumns.map(col =>
  //           UPDATE_COLUMN_POSITION({
  //             variables: {
  //               data: { id: col._id, columnPosition: col.columnPosition },
  //             },
  //           }),
  //         ),
  //       );
  //     } catch (error) {
  //       console.error("Failed to update column positions", error);
  //     }

  //     return;
  //   }

  //   const startKey = source.droppableId;
  //   const finishKey = destination.droppableId;

  //   setColumnsState(prev => {
  //     const startCol = prev[startKey];
  //     const finishCol = prev[finishKey];

  //     if (startKey === finishKey) {
  //       const newItems = Array.from(startCol.items);
  //       const [moved] = newItems.splice(source.index, 1);
  //       newItems.splice(destination.index, 0, moved);

  //       return {
  //         ...prev,
  //         [startKey]: { ...startCol, items: newItems },
  //       };
  //     }

  //     const startItems = Array.from(startCol.items);
  //     const [moved] = startItems.splice(source.index, 1);

  //     const finishItems = Array.from(finishCol.items);
  //     finishItems.splice(destination.index, 0, { ...moved, statusId: finishKey });

  //     return {
  //       ...prev,
  //       [startKey]: { ...startCol, items: startItems },
  //       [finishKey]: { ...finishCol, items: finishItems },
  //     };
  //   });

  //   if (startKey !== finishKey) {
  //     try {
  //       await UPDATE_KANBAN({
  //         variables: { data: { id: draggableId, statusId: finishKey } },
  //       });
  //     } catch (err) {
  //       console.error("Status update failed:", err);
  //     }
  //   }
  // };

  const handleDragEnd = async (result) => {
    const { source, destination, draggableId, type } = result;
    if (!destination) return;

    if (type === "COLUMN") {
      const sortedColumns = [...kanbanColumns].sort((a, b) => a.columnPosition - b.columnPosition);
      const [movedCol] = sortedColumns.splice(source.index, 1);
      sortedColumns.splice(destination.index, 0, movedCol);

      const updatedColumns = sortedColumns.map((col, idx) => ({
        ...col,
        columnPosition: idx + 1,
      }));

      setKanbanColumns(updatedColumns);

      try {
        await Promise.all(
          updatedColumns.map(col =>
            UPDATE_COLUMN_POSITION({
              variables: { data: { id: col._id, columnPosition: col.columnPosition } },
            })
          )
        );
      } catch (error) {
        console.error("Failed to update column positions", error);
      }

      return;
    }

    const startKey = source.droppableId;
    const finishKey = destination.droppableId;

    setColumnsState((prev) => {
      const startCol = prev[startKey];
      const finishCol = prev[finishKey];

      // Moving inside the same column
      if (startKey === finishKey) {
        const newItems = Array.from(startCol.items);
        const [moved] = newItems.splice(source.index, 1);
        newItems.splice(destination.index, 0, moved);

        return {
          ...prev,
          [startKey]: { ...startCol, items: newItems },
        };
      }

      // Moving to another column
      const startItems = Array.from(startCol.items);
      const [moved] = startItems.splice(source.index, 1);

      // Find the new status name from the column
      const newStatus = kanbanColumns.find(col => col.columnId === finishKey)?.title || "";

      const finishItems = Array.from(finishCol.items);
      finishItems.splice(destination.index, 0, { ...moved, statusId: finishKey, status: newStatus });

      return {
        ...prev,
        [startKey]: { ...startCol, items: startItems },
        [finishKey]: { ...finishCol, items: finishItems },
      };
    });

    // Update backend only if moving to another column
    if (startKey !== finishKey) {
      const newStatus = kanbanColumns.find(col => col.columnId === finishKey)?.title || "";
      try {
        await UPDATE_KANBAN({
          variables: {
            data: { id: draggableId, statusId: finishKey, status: newStatus },
          },
        });
      } catch (err) {
        console.error("Status update failed:", err);
      }
    }
  };

  const handleCreatePipeline = async ({ title }) => {
    try {
      await CREATE_KANBAN_COLUMN({
        variables: {
          data: {
            title,
            name: title,
            projectId,
          },
        },
        onCompleted: ({ CreateKanbanColumn }) => {
          setKanbanColumns(CreateKanbanColumn);
        },
        onError: error => {
          handleOpen(true, error?.message || "server error");
        },
      });
      setShowPipelineModal(false);
    } catch (error) {
      console.error("Error creating column:", error);
    }
  };

  const handleDeletePipeline = async col => {
    try {
      await DELETE_KANBAN_COlUMN({
        variables: { data: { id: col._id, projectId: col.projectId } },
      });

      setKanbanColumns(kanbanColumns.filter(colm => colm._id !== col._id));
    } catch (error) {
      console.log(error.message);
      handleOpen(true, error?.message || "server error");
    }
  };

  const handleUpdatePipeline = async updatedData => {
    try {
      const { data } = await UPDATE_KANBAN_COLUMN({
        variables: {
          data: {
            id: updatedData._id,
            title: updatedData.title,
            projectId: updatedData.projectId,
          },
        },
      });

      setKanbanColumns(prev => prev.map(col => (col._id === updatedData._id ? { ...col, title: updatedData.title } : col)));
      setEditPipelineModal(false);
    } catch (error) {
      console.error("Error updating pipeline:", error);
      handleOpen(true, error?.message || "Server error");
    }
  };

  const handleBack = () => {
    const path = searchParams.get("path");
    if (path === "dashboard") navigate("/dashboard?menu=dashboard");
    else if (path === "issue") navigate(`/issuesflag/${projectId}`);
  };

  useEffect(() => {
    if (kanbanColumns?.length) {
      const dynamicState = {};
      kanbanColumns.forEach(col => {
        const colId = col.columnId;
        dynamicState[colId] = columnsState[colId] || {
          items: [],
          offset: 0,
          hasMore: false,
          loading: false,
        };
      });

      setColumnsState(dynamicState);
    }
  }, [kanbanColumns]);

  useEffect(() => {
    const handleClickOutside = event => {
      if (tagInputVisibleFor && inputRef.current && !inputRef.current.contains(event.target)) {
        setTagInputVisibleFor(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [tagInputVisibleFor]);

  const isAllColumnsEmpty = useMemo(() => {
    return Object.values(columnsState).every(col => {
      const filteredItems = (col?.items || []).filter(task => {
        const matchPriority =
          !filters.priority || task.priority === filters.priority;

        const matchAssignee =
          !filters.assignee._id ||
          task.assignees?.some(a => a === filters.assignee);
        // OR: task.assignee === filters.assignee

        const matchTag =
          !filters.tag ||
          task.tags?.some(tag => tag.value === filters.tag);

        return matchPriority && matchAssignee && matchTag;
      });

      return filteredItems.length === 0;
    });
  }, [columnsState, filters]); // FIXED

  // const isAllColumnsEmpty = useMemo(() => { 
  //   return Object.values(columnsState).every(col => { 
  //     const filteredItems = (col?.items || []).filter(task => !selectedPriority || task.priority === selectedPriority); 
  //     return filteredItems.length === 0; 
  //   }); 
  // }, [columnsState, selectedPriority]);

  const wrapperRef = useRef(null);
  const [wrapperWidth, setWrapperWidth] = useState(0);
  useEffect(() => {
    const handleResize = entries => {
      for (let entry of entries) {
        setWidthLoader(true);
        setWrapperWidth(entry.contentRect.width);
        setTimeout(() => {
          setWidthLoader(false);
        }, 300);
      }
    };
    const observer = new ResizeObserver(handleResize);
    if (wrapperRef.current) {
      observer.observe(wrapperRef.current);
    }
    return () => {
      if (wrapperRef.current) {
        observer.unobserve(wrapperRef.current);
      }
    };
  }, [wrapperRef]);

  useEffect(() => {
    setWidthLoader(!widthLoader);
  }, [customizer?.isSidebarCollapse]);
  const handleIssueSave = async () => {
    const updated = await handleUpdatedIssue(); // get updated issue from popup

    if (updated) {
      setColumnsState(prev => {
        const newState = { ...prev };
        for (const colId in newState) {
          newState[colId].items = newState[colId].items.map(item => (item._id === updated.issueId ? { ...item, ...updated } : item));
        }
        return newState;
      });
    }
  };
  const updateIssueInBoard = updatedIssue => {
    setColumns(prevColumns => {
      const newColumns = { ...prevColumns };

      // Loop over columns and find the matching item
      Object.keys(newColumns).forEach(columnId => {
        newColumns[columnId].items = newColumns[columnId].items.map(item => {
          if (item._id === updatedIssue._id) {
            return { ...item, ...updatedIssue }; // merge updates
          }
          return item;
        });
      });

      return newColumns;
    });
  };

  const getEndDateDisplay = endDateRaw => {
    if (!endDateRaw) return { color: "inherit", text: "" };

    const endDate = new Date(endDateRaw);
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    endDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    tomorrow.setHours(0, 0, 0, 0);

    const isPastDate = endDate < today;
    const isTodayDate = endDate.getTime() === today.getTime();
    const isTomorrowDate = endDate.getTime() === tomorrow.getTime();

    let displayText = endDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
    });

    if (isTodayDate) displayText = "Today";
    else if (isTomorrowDate) displayText = "Tomorrow";

    const endDateColor = isPastDate || isTodayDate ? "#CC3F74" : isTomorrowDate ? "#F27C27" : "inherit";

    return { color: endDateColor, text: displayText };
  };

  const checkOverflow = (columnId) => { // Check if a column is overflowing
    const el = columnBodyRefs.current[columnId];
    if (!el) return false;

    return el.scrollHeight >= el.clientHeight;
  };

  useEffect(() => {
    const overflowState = {};

    Object.keys(columnBodyRefs.current).forEach((columnId) => {
      const el = columnBodyRefs.current[columnId];
      // console.log("Checking overflow for column:", el);
      if (!el) return;
      // console.log(`Column ID: ${columnId}, scrollHeight: ${el.scrollHeight}, clientHeight: ${el.clientHeight}`);

      overflowState[columnId] = el.scrollHeight >= 2574 ; // Adjusted threshold for "Show More" button
    });
    // console.log("overflowState:", overflowState);

    setIsOverflowing(overflowState);
  }, [columnsState, filters]);



  // console.log("filters:", filters);
  // console.log("columnsState:", columnsState);
  // console.log(
  //   "columnsState:",
  //   (Object.values(columnsState)[0]?.items || []).filter(task =>
  //     task.assignee === filters.assignee
  //   )
  // );

  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12} md={12}>
              <Box ref={wrapperRef} sx={{ width: "100%" }}>
                <KanbanBoardHeader
                  selectedPriority={filters.priority}
                  getPriorityFilteredFlags={getPriorityFilteredFlags}
                  selectedFlags={selectedFlags}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12} md={12}>
              {loading || !kanbanLoad ? (
                <MainLoader message="Loading..." />
              ) : selectedFlags.length === 0 && isAllColumnsEmpty ? (
                <KanbanEmptyState projectId={projectId} />
              ) : isAllColumnsEmpty ? (
                "No Data Found"
              ) : (
                <>
                  <Card
                    className="DragListFilterWrapper"
                    sx={{
                      padding: "16px 16px 0px 16px",
                      border: `1px solid ${theme.palette.divider}`,
                      boxShadow: "none !important",
                      borderBottom: "none",
                      borderBottomLeftRadius: "0px",
                      borderBottomRightRadius: "0px",
                    }}
                  >
                    <Box className="ContentWrapper">
                      <Typography component="h2">Improving Work Processes</Typography>
                      <Button onClick={() => setShowPipelineModal(true)} className="FilledBtn">
                        Add Pipeline
                      </Button>
                    </Box>
                    <Box className="FilterWrapper">
                      <FormControl className="DropDownWrapper">
                        {/* <Select value={selectedPriority} displayEmpty onChange={e => setSelectedPriority(e.target.value)}> */}
                        <Select value={filters.priority} displayEmpty onChange={e => updateFilter("priority", e.target.value)}
                        >
                          <MenuItem value="">Select Priority</MenuItem>
                          <MenuItem value="High">High</MenuItem>
                          <MenuItem value="Medium">Medium</MenuItem>
                          <MenuItem value="Low">Low</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl className="DropDownWrapper">
                        <Select
                          value={filters.assignee}
                          displayEmpty
                          onChange={e => updateFilter("assignee", e.target.value)}
                        >
                          <MenuItem value="">Select Assignees</MenuItem>
                          {!teamMembersLoading &&
                            teamMembers.map(member => (
                              <MenuItem key={member._id}  value={member._id}>
                                {member.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                      <FormControl className="DropDownWrapper">
                        {/* <Select value={selectedPriority} displayEmpty onChange={e => setSelectedPriority(e.target.value)}> */}
                        <Select value={filters.tag} displayEmpty onChange={e => updateFilter("tag", e.target.value)}>
                          <MenuItem value="">Select Tag</MenuItem>
                          <MenuItem value="UI">UI</MenuItem>
                          <MenuItem value="Developer">Developer</MenuItem>
                          <MenuItem value="UI/UX">UI/UX</MenuItem>
                        </Select>
                      </FormControl>
                      <Button onClick={() => setFilters({ priority: "", assignee: "", tag: "" })}>
                        <RefreshIcon className={false ? "Rotate" : ""} />
                        Reset Filter
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<GroupAddIcon />}
                        onClick={() => setShowAddTeamMember(true)}
                      >
                        Add Team Member
                      </Button>

                    </Box>
                  </Card>
                  <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="columns" direction="horizontal" type="COLUMN">
                      {provided => (
                        <Card
                          className="DragListMainWrapper"
                          sx={{
                            padding: "16px 16px 16px 16px",
                            border: `1px solid ${theme.palette.divider}`,
                            boxShadow: "none !important",
                            borderTop: "none",
                            borderTopLeftRadius: "0px",
                            borderTopRightRadius: "0px",
                          }}
                          style={{ width: wrapperWidth }}
                        >
                          <Box ref={provided.innerRef} {...provided.droppableProps} className="DragInnerListWrapper">
                            {kanbanColumns?.map((col, index) => (
                              <Draggable key={col.columnId} draggableId={col.columnId} index={index}>
                                {providedCol => (
                                  <Box ref={providedCol.innerRef} {...providedCol.draggableProps} className={`MainBlockWrapper ${col.name || ""}`}>
                                    <Box {...providedCol.dragHandleProps} className="BlockHeadWrapper">
                                      <Typography component="h4">{col.title}</Typography>
                                      <Box className="BtnWrapper">
                                        <EditOutlinedIcon onClick={() => handleEditPipeline(col)} />
                                        <DeleteOutlineIcon
                                          onClick={() => {
                                            setSelectedPipeline(col);
                                            setShowDeleteModal(true);
                                          }}
                                        />
                                      </Box>
                                    </Box>
                                    <Droppable droppableId={col.columnId} type="TASK">
                                      {providedInner => (
                                        // <Box ref={providedInner.innerRef} {...providedInner.droppableProps} className="BlockBodyWrapper">
                                        <Box
                                          ref={(el) => {
                                            providedInner.innerRef(el);
                                            columnBodyRefs.current[col.columnId] = el;
                                          }}
                                          {...providedInner.droppableProps}
                                          className="BlockBodyWrapper"
                                        >
                                          {(columnsState[col.columnId]?.items || [])
                                            // .filter(task => !selectedPriority || task.priority === selectedPriority)
                                            .filter(task => {
                                              const matchPriority =
                                                !filters.priority || task.priority === filters.priority;

                                              const matchAssignee =
                                                !filters.assignee ||
                                                task.assignees?.some(a => a === filters.assignee);

                                              const matchTag =
                                                !filters.tag ||
                                                task.tags?.some(tag => tag.value === filters.tag);

                                              return matchPriority && matchAssignee && matchTag;
                                            })

                                            .map((task, index) => (
                                              <Draggable key={task._id} draggableId={task._id} index={index}>
                                                {providedDrag => (
                                                  <Box
                                                    ref={providedDrag.innerRef}
                                                    {...providedDrag.draggableProps}
                                                    {...providedDrag.dragHandleProps}
                                                    onClick={() => {
                                                      setSelectedIssue(task);
                                                      setOpen(true);
                                                    }}
                                                    className="DragBoxWrapper"
                                                  >
                                                    <Box className="ContentWrapper">
                                                      <Box className="StatusTagsWrapper">
                                                        <Typography component="span">{task.status}</Typography>
                                                        <Typography component="span" className={`FlagTag ${task.priority || ""}`}>
                                                          <FlagIcon />
                                                          {task.priority}
                                                        </Typography>
                                                      </Box>
                                                      <Typography component="span" className="IssueName" title={task.flag}>
                                                        {task.flag}
                                                      </Typography>
                                                      <Typography component="h3">{task.title}</Typography>
                                                      <Link href={task.url} target="_blank" rel="noopener noreferrer" title={task.url}>
                                                        {task.url}
                                                      </Link>

                                                      <Box className="TagsWrapper">
                                                        {task?.tags?.map(tag => (
                                                          <Typography component="span" key={tag.id}>
                                                            {tag.value}
                                                          </Typography>
                                                        ))}
                                                      </Box>

                                                      <Box className="FooterWrapper">
                                                        <Box className="AssignWrapper">
                                                          <Avatar src="/croken-image.jpg">jr</Avatar>
                                                          <Avatar src="/croken-image.jpg">rs</Avatar>
                                                          <Avatar src="/croken-image.jpg">as</Avatar>
                                                          <Avatar className="MoreAvatar">20+</Avatar>
                                                        </Box>

                                                        <Box className="InfoWrapper">
                                                          <Box className="InfoInnerWrapper" title={"Comments - " + (task?.comments?.length || "0")}>
                                                            <TextsmsOutlinedIcon sx={{ marginTop: "3px", fontSize: "20px !important" }} />
                                                            {task?.comments?.length || "0"}
                                                          </Box>
                                                          {task?.dateRange?.endDate &&
                                                            (() => {
                                                              const { color, text } = getEndDateDisplay(task.dateRange.endDate);
                                                              return (
                                                                <Box className="InfoInnerWrapper" sx={{ color }} title={"Due Date - " + text}>
                                                                  <CalendarMonthOutlinedIcon />
                                                                  {text}
                                                                </Box>
                                                              );
                                                            })()}
                                                        </Box>
                                                      </Box>
                                                    </Box>
                                                  </Box>
                                                )}
                                              </Draggable>
                                            ))}
                                          {providedInner.placeholder}

                                          {/* {columnsState[col.columnId]?.hasMore && (
                                            <Box className="ShowMoreBtnWrapper">
                                              <Button onClick={() => fetchIssuesByStatus(col.columnId)}>Show More</Button>
                                            </Box>
                                          )} */}
                                          {columnsState[col.columnId]?.hasMore &&
                                            isOverflowing[col.columnId] &&
                                            (
                                              <Box className="ShowMoreBtnWrapper">
                                                <Button onClick={() => fetchIssuesByStatus(col.columnId)}>
                                                  Show More
                                                </Button>
                                              </Box>
                                            )}

                                        </Box>
                                      )}
                                    </Droppable>
                                  </Box>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </Box>
                        </Card>
                      )}
                    </Droppable>
                  </DragDropContext>
                </>
              )}
            </Grid>
          </Grid>
        </Box>
      </Container>
      {open && (
        <IssuePopup
          open={open}
          handleClose={handleClose}
          setWidthLoader={setWidthLoader}
          issueId={selectedIssue?._id}
          setOpen={setOpen}
          issueData={selectedIssue}
          refetchKanban={fetchInitialKanbanData}
          setSelectedIssue={setSelectedIssue}
          updateIssueInBoard={updateIssueInBoard}
          teamMembers={teamMembers}
          onAssigneesChange={handleAssigneesChange}
          handleAddTag={async (issueId, value) => {
            if (!value || typeof value !== "string") return null;

            const trimmed = value.trim();
            if (!trimmed) return null;

            try {
              await ADD_TAGS({
                variables: {
                  data: {
                    issueId,
                    tag: trimmed,
                  },
                },
              });

              return {
                id: Date.now().toString(),
                value: trimmed,
              };
            } catch (err) {
              console.error("Failed to add tag", err);
              return null;
            }
          }}
          handleDeleteTag={async (issueId, tagId) => {
            await DELETE_TAG({
              variables: {
                data: { issueId, id: tagId },
              },
            });
          }}
          handleUpdateTag={(issueId, tagId, value) => UPDATE_TAG({ variables: { data: { issueId, tagId, value } } })}
        />
      )}

      <PipelineModal
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        handleDeletekanban={async () => {
          await handleDeletePipeline(selectedPipeline);
          setShowDeleteModal(false);
        }}
        isDelete={true}
      />
      {showAddTeamMember && (
        <AddTeamMember
          open={showAddTeamMember}
          onClose={() => setShowAddTeamMember(false)}
          projectId={projectId}
          onMemberAdded={refetchTeamMembers}
        />
      )}

      <PipelineModal open={showPipelineModal} onClose={() => setShowPipelineModal(false)} onSubmit={handleCreatePipeline} initialData={editPipelineData} />
      <PipelineModal open={editPipelineModal} onClose={() => setEditPipelineModal(false)} onSubmit={handleUpdatePipeline} initialData={editPipelineData} />
    </SectionWrapper>
  );
}

export default KanbanView;
